export const REASON_2FA_LOGIN = 'LOGIN';

export const REASON_2FA = {
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    EMAIL: 'EMAIL',
    GRID: 'GRID',
    IBAN: 'IBAN',
    PERSONAL_DATA: 'PERSONAL_DATA',
    PHONE_NUMBER: 'PHONE_NUMBER'
};

export function isImplicitReason(reason) {
    return reason !== REASON_2FA_LOGIN;
}
